import { useQuery } from '@tanstack/react-query';

import { handleError } from '../../../../../utils/admin';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { unwrapNonPaginatedResponseDataAs } from '../../../../logic/unwrapNonPaginatedResponseDataAs';
import { SUMMARIES_BASE_PATH } from '../../constants/summariesBasePath';
import { getSummaries } from '../../requests/getSummaries';

export const useSummaries = (
  definitionName: string,
  template: string,
  options?: { enabled?: boolean },
) => {
  const { constructGet } = useRequestConstructor();

  const { data, refetch, ...rest } = useQuery<
    Awaited<ReturnType<typeof getSummaries>>
  >({
    queryKey: [SUMMARIES_BASE_PATH, definitionName, template],
    queryFn: () => getSummaries(constructGet, definitionName, template),
    enabled:
      Boolean(definitionName) &&
      Boolean(template) &&
      (options?.enabled ?? true),
    onSuccess: (responseData) => {
      if (responseData?.data?.length === 0) {
        handleError('Summary definition was not found.');
      }
    },
  });

  return {
    ...unwrapNonPaginatedResponseDataAs(data, refetch, 'summaries'),
    ...rest,
  };
};
